import * as model from 'app/features/orders/models'
import {mapToVariantAllowNegativeInventoryModel, sellingPrice} from '../../helper'
import {cleanModel} from 'app/utilities'
import _ from 'lodash'
import {discountValueType} from '../../models/DiscountCode'

export const mapToDraftOrderModel = (order: any) => {
  const variants: any = mapToVariantAllowNegativeInventoryModel(order.draftOrderItems.nodes)
  const items: model.DraftOrderItem[] = variants.map((item: any) => {
    const {variant} = item
    const price: any = sellingPrice(variant)
    return {
      id: item.id,
      productId: item.productId,
      variantId: item.variantId,
      quantity: parseInt(item.quantity),
      price: parseFloat(variant.price),
      discountPrice: variant.discountPrice,
      totalPrice: parseFloat(price) * parseInt(item.quantity),
      variant: variant.name,
      product: item.product,
      available: item.variant.available,
      shipAvailableForAdminPortal: item.variant.shipAvailableForAdminPortal,
      pickupAvailableForAdminPortal: item.variant.pickupAvailableForAdminPortal,
    }
  })
  const draftOrder: model.DraftOrder = {
    id: order.id,
    customerId: order.customerId,
    shippingAddressId: order.shippingAddressId,
    billingAddressId: order.billingAddressId,
    name: order.name,
    status: order.status,
    subtotalPrice: parseFloat(order.subtotalPrice),
    totalPrice: parseFloat(order.totalPrice),
    totalTax: parseFloat(order.totalTax),
    totalDiscounts: parseFloat(order.totalDiscounts),
    shippingPrice: parseFloat(order.shippingPrice),
    items,
    deletedItems: [],
    shippingRateId: order.shippingRateId,
    paymentMethodId: order.paymentMethodId,
    isCompliant: false,
    shippingRate: cleanModel(order.shippingRate),
    orderDeliveryMethod: order.orderDeliveryMethod,
    wineClubDiscounts: parseFloat(order.wineClubDiscounts),
    isFreeShipping: order?.isFreeShipping,
    note: order.note || '',
    salesTax: order.salesTax ? parseFloat(order.salesTax) : 0,
    crv: order.crv ? parseFloat(order.crv) : 0,
    hasWineClub: order.hasWineClub,
    paymentType: order?.paymentType || 'CARD',
    isAutoDiscountRemoved: order.isAutoDiscountRemoved,
    isTaxRemoved: order.isTaxRemoved,
  }
  return draftOrder
}

export const calculateTotalPrice = (order: model.DraftOrder) => {
  return (
    order.subtotalPrice +
    order.totalTax +
    order.shippingPrice -
    order.totalDiscounts -
    order.wineClubDiscounts
  )
}

export const calculateSubtotalPrice = (items: model.DraftOrderItem[]) => {
  return items.reduce((sum, item) => sum + item.totalPrice, 0)
}

export const mapToDiscountModel = (
  discounts: any[],
  totalPrice: number | any,
  isCompleted?: boolean
) => {
  let isPromoCode = false,
    isWineClub = false,
    isShipping = false,
    totalDiscounts = 0,
    wineClubDiscounts = 0,
    discountCodeId = null,
    shippingDiscountCodeId = null,
    code = '',
    name = '',
    shipDiscountCode = '',
    isFreeShipping = false,
    shipDiscountName = '',
    isCustomerAutoDiscount = false

  discounts.forEach((discount: any) => {
    if (discount.isPromoCode) {
      isPromoCode = true
      totalDiscounts = parseFloat(discount.amount)
      discountCodeId = discount.discountCodeId
      code = discount.code
    }

    if (discount.isShipping) {
      shipDiscountCode = discount.code
      isFreeShipping = findFreeShippingDiscount(discount)
      if (isFreeShipping) {
        shipDiscountCode = discount.code
      }
      if (isCompleted) {
        shipDiscountCode = discount.code ?? discount.name
      }
      isShipping = true
      shipDiscountName = discount.name
      shippingDiscountCodeId = discount.discountCodeId
    }

    if (discount.isWineClub) {
      if (discount.autoDiscountType === 'all_customers') {
        wineClubDiscounts = parseFloat(discount.amount)
        name = discount.name
        isCustomerAutoDiscount = true
      } else {
        isWineClub = true
        wineClubDiscounts = parseFloat(discount.amount)
        name = discount.name
      }
    }
  })

  return {
    isPromoCode,
    isWineClub,
    isShipping,
    totalDiscounts,
    wineClubDiscounts,
    discountCodeId,
    code,
    name,
    shippingDiscountCodeId,
    shipDiscountCode,
    isFreeShipping,
    shipDiscountName,
    isCustomerAutoDiscount,
  }
}

export const findFreeShippingDiscount = (discount: any) => {
  if (findDiscountPercentage(discount)) {
    return true
  }
  return false
}

const findDiscountPercentage = (discount: any) => {
  return (
    discount.valueType === _.toLower(discountValueType.PERCENTAGE) &&
    parseFloat(discount.discountValue) === 100
  )
}
